import { FIELD_TYPES } from 'src/constants/Fields';

const fundraisingTransactions = [
  {
    field: 'event_transactions.id',
    minWidth: 150,
    type: FIELD_TYPES.number,
  },
  {
    field: 'event_transactions.invoice_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'event_transactions.payment_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
  },
  {
    field: 'event_transactions.event_id',
    minWidth: 150,
    type: FIELD_TYPES.string,
    hide: true,
    hide_in_search: true,
  },
  {
    field: 'event_transactions.contact_id',
    minWidth: 150,
    type: FIELD_TYPES.contact,
    hide: true,
  },
  {
    field: 'event_transactions.ambassador_id',
    minWidth: 150,
    type: FIELD_TYPES.number,
    hide: true,
    hide_in_search: true,
  },
  {
    field: 'ambassadors.name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_transactions.title',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'payment_gateways.gateway_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'payments.payment_gateway_id',
    minWidth: 150,
    type: FIELD_TYPES.string,
    hide: true,
    hide_in_search: true,
  },
  {
    field: 'event_transactions.donor_name_displayed',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_transactions.is_anonymous',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.first_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.last_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.company_name',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.billing_address',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.billing_city',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.billing_state',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.billing_suite',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.billing_zip_code',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'contacts.billing_country_id',
    minWidth: 150,
    type: FIELD_TYPES.country,
  },
  {
    field: 'event_transactions.amount_multiplier',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'invoices.total',
    minWidth: 150,
    type: FIELD_TYPES.money,
  },
  {
    field: 'invoices.payment_status',
    minWidth: 150,
    type: FIELD_TYPES.invoicePaymentStatus,
  },
  {
    field: 'payments.payment_type',
    minWidth: 150,
    type: FIELD_TYPES.paymentType,
  },
  {
    field: 'event_transactions.donor_comment',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_transactions.source_reference',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_transactions.source_reference_url',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_transactions.show_pledge',
    minWidth: 150,
    type: FIELD_TYPES.string,
  },
  {
    field: 'event_transactions.pledge_date',
    minWidth: 150,
    type: FIELD_TYPES.datetime,
  },
];

export default fundraisingTransactions;
